import { useState, useEffect, forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const COOKIE_KEY = "ir_cookie_consent";

const CookieConsent = forwardRef<HTMLDivElement>((_, ref) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (value: string) => {
    localStorage.setItem(COOKIE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div ref={ref} className="fixed bottom-0 left-0 right-0 z-[60] p-4 animate-fade-up">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-foreground text-background border border-foreground/20 shadow-xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="text-sm text-background/80 flex-1">
            Utilizamos cookies para melhorar a sua experiência. Ao continuar a navegar, concorda com a nossa{" "}
            <Link to="/privacidade" className="text-background underline hover:text-background/70 font-medium">
              Política de Privacidade
            </Link>{" "}
            e{" "}
            <Link to="/termos" className="text-background underline hover:text-background/70 font-medium">
              Termos e Condições
            </Link>.
          </p>
          <div className="flex gap-2 shrink-0">
            <button
              onClick={() => accept("essential")}
              className="text-xs font-medium border border-white/60 text-white px-3 py-1.5 hover:bg-white/20 transition-colors"
            >
              Apenas essenciais
            </button>
            <Button
              size="sm"
              onClick={() => accept("all")}
              className="text-xs bg-background text-foreground hover:bg-background/90"
            >
              Aceitar todos
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

CookieConsent.displayName = "CookieConsent";

export default CookieConsent;
